export default "__VITE_ASSET__DRUIQNUy__"